import { ClipboardList } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { BitacorasTab } from './BitacorasTab';
import type { MantenimientoRow } from '../api';

/**
 * Quick-access popup for the note/clipboard icon on a Mantenimiento
 * row. Mirrors PowerApps `PopUpBitacoras`: list existing bitácoras and
 * add new ones without dropping into the full venta detail screen.
 *
 * Same form + list as the Bitácoras action inside DetalleMantenimientoPage;
 * we wrap it here so admins can log a service note straight from the
 * gallery.
 */
export function BitacorasQuickDialog({
  row,
  onClose,
}: {
  row: MantenimientoRow;
  onClose: () => void;
}) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ClipboardList className="h-5 w-5 text-muted-foreground" aria-hidden />
            Bitácoras — venta Nº {row.id}
          </DialogTitle>
          <DialogDescription>
            {row.fields.Cliente_RO || '—'}
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <BitacorasTab ventaId={row.id} />
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
